import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { wishListProducts } from "./FetchApi";
import { X } from "lucide-react";

const Product = () => {
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const responseData = await wishListProducts();
    if (responseData?.Products) {
      setProducts(responseData.Products);
    }
    setLoading(false);
  };

  const removeFromWishList = (id) => {
    const list = JSON.parse(localStorage.getItem("wishList")) || [];
    if (list.includes(id)) {
      const updated = list.filter((item) => item !== id);
      localStorage.setItem("wishList", JSON.stringify(updated));
      fetchData();
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg text-gray-600 animate-pulse">
          Carregando seus produtos curtidos...
        </div>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center text-gray-500 py-12">
        Nenhum produto marcado como "gostei" até agora.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4">
      {products.map((product) => (
        <div
          key={product._id}
          className="relative flex flex-col md:flex-row items-start md:items-center justify-between p-4 border rounded-xl shadow-sm hover:shadow-md transition bg-white"
        >
          {/* Info do produto */}
          <div className="flex items-start space-x-4 md:w-1/2">
            <img
              onClick={() => history.push(`/products/${product._id}`)}
              className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-md cursor-pointer border"
              src={`${process.env.REACT_APP_API_URL}/uploads/products/${product.pImages[0]}`}
              alt={product.pName}
              onError={(e) => (e.target.src = "/default-product.png")}
            />
            <div className="min-w-0">
              <h3 className="text-base sm:text-lg font-semibold text-gray-800 break-words leading-snug">
                {product.pName}
              </h3>
              <div className="text-sm text-gray-600 mt-1">
                {product.pQuantity > 0 ? (
                  <span className="text-green-600 font-medium">Disponível</span>
                ) : (
                  <span className="text-red-500 font-medium">Sem estoque</span>
                )}
              </div>
            </div>
          </div>

          {/* Ações */}
          <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:w-1/2 md:justify-end mt-4 md:mt-0">
            <div className="text-sm text-gray-700 font-semibold">
              R$ {product.pPrice?.toFixed(2).replace(".", ",")}
            </div>
            <button
              onClick={() => history.push(`/products/${product._id}`)}
              className="px-4 py-1.5 bg-flitz-primary text-white text-sm rounded hover:opacity-90 transition"
            >
              Ver produto
            </button>
          </div>

          {/* Remover */}
          <button
            onClick={() => removeFromWishList(product._id)}
            className="absolute top-2 right-2 text-gray-400 hover:text-red-500 transition"
            title="Remover da Lista"
          >
            <X size={20} />
          </button>
        </div>
      ))}
    </div>
  );
};

const SingleWishProduct = () => {
  return (
    <section className="mx-4 mt-20 md:mx-12 md:mt-32 lg:mt-24">
      <div className="mb-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-flitz-primary">Produtos curtidos</h2>
        <p className="text-sm text-gray-500 mt-1">
          Aqui estão os itens que você marcou como “gostei”.
        </p>
      </div>
      <Product />
    </section>
  );
};

export default SingleWishProduct;